export const BREVET_SUBJECTS = [
    { id: "maths", label: "Maths", short: "Maths" },
    { id: "francais", label: "Français", short: "Français" },
    { id: "histoire_geo", label: "Histoire-Géo", short: "Hist-Géo" },
    { id: "sciences", label: "Sciences (PC/SVT)", short: "Sciences" },
    { id: "oral", label: "Oral", short: "Oral" },
]

export const BREVET_MODULES_BY_SUBJECT = {
    maths: [
        { id: "maths_equations", label: "Équations & calcul littéral" },
        { id: "maths_thales_pythagore", label: "Thalès & Pythagore" },
        { id: "maths_scratch_stats", label: "Scratch & Stats" },
        { id: "maths_fonctions", label: "Fonctions & graphiques" },
    ],
    francais: [
        { id: "fr_grammaire", label: "Grammaire & Réécriture" },
        { id: "fr_analyse", label: "Analyse de texte" },
        { id: "fr_dictee", label: "Dictée" },
        { id: "fr_redaction", label: "Rédaction" },
    ],
    histoire_geo: [
        { id: "hg_developpement", label: "Développement construit" },
        { id: "hg_reperes", label: "Repères & cartes" },
        { id: "hg_doc", label: "Analyse de doc" },
    ],
    sciences: [
        { id: "sc_raisonnement", label: "Raisonnement scientifique" },
        { id: "sc_calculs", label: "Calculs & unités" },
    ],
    oral: [
        { id: "oral_prise_parole", label: "Prise de parole" },
        { id: "oral_contenu", label: "Contenu & éloquence" },
    ],
}

export const getModulesForSubjects = (subjectIds) =>
    subjectIds.flatMap((id) =>
        (BREVET_MODULES_BY_SUBJECT[id] || []).map((m) => ({
            ...m,
            subjectId: id,
        }))
    )
